/**
 * @file
 * App Configuration
 *
 * This file provides the standard configuration of this webapp
 */

/**
 * App Configuration
 */
export abstract class AppConfig {
  /**
   * Default colors
   */
  static readonly primaryColor = '#ffbb16'
  static readonly secondaryColor = '#b71c1c'
  static readonly tertiaryColor = '#404041'
  static readonly successColor = '#9bff2d'
  static readonly warningColor = '#f2ad09'
  static readonly dangerColor = '#b71c1c'

  /**
   * Filter debounce wait time
   */
  static readonly debounceWaitTime = 1000

  /**
   * First date for year filter
   */
  static readonly firstDate = '2017-01-01T00:00:00-03:00'

  /**
   * First date for excel
   */
  static readonly excelFirstDate = '1899-12-31'

  /**
   * Fields to render at view components
   */
  static readonly fieldsToRender = {
    reportsDeliverySacPublic: {
      Carga: [
        'nroNotaFiscal',
        'dataInclusao',
        'embarcadorCpfCnpjAlt',
        'embarcadorRazaoSocialAlt',
        'nomeDestinatario',
      ],
    },
    reportsDeliverySacAgcoPublic: {
      Carga: [
        'nroNotaFiscal',
        'dataCriacao',
        'embarcadorCpfCnpjAlt',
        'embarcadorRazaoSocialAlt',
        'nomeDestinatario',
        'dataPrevisao',
        'statusCarga',
      ],
      CargaObservacao: ['observacaoEntrega'],
    },
    reportsDeliverySacBostonPublic: {
      Carga: [
        'nroNotaFiscal',
        'dataCriacao',
        'embarcadorCpfCnpjAlt',
        'embarcadorRazaoSocialAlt',
        'nomeDestinatario',
      ],
    },
    reportsDeliverySac: {
      Carga: [
        'danfe',
        'nroNotaFiscal',
        'nroCteAlt',
        'cpfCnpjDestinatario',
        'nomeDestinatario',
      ],
      CargaSession1: ['nroNotaFiscal', 'danfe', 'cte'],
      CargaSessionPrivate: ['nroNotaFiscal', 'dataPrevisao',  'nroCte', 'danfe'],
      CargaSessionPrivateAlt: [
        'nroNotaFiscal',
        'dataPrevisao',
        'nroCte',
        'dataPrevisaoAtualizadaPrivate',
        'observacaoPrevisaoPrivate',
        'danfe',
      ],
      CargaSessionPrivateAltIvecoCnh: [
        'nroNotaFiscal',
        'dataPrevisao',
        'nroCte',
        'dataPrevisaoAtualizadaPrivate',
        'observacaoPrevisaoPrivate',
        'danfe',
        'lastUpdate',
      ],
      CargaSessionPublic: [
        'nroNotaFiscal',
        'danfe',
        'nroCte',
        'dataPrevisao',
        'distanciaParaDestinoEmMetros',
        'duracaoParaDestinoEmSegundos',
      ],
      CargaSessionAgcoPublic: [
        'nroNotaFiscal',
        'nroCte',
        'dataPrevisao',
        'distanciaParaDestinoEmMetros',
        'duracaoParaDestinoEmSegundos',
      ],
      CargaSession2: [
        'nroNotaFiscal',
        'danfe',
        'cte',
        'dataPrevisao',
        'distanciaParaDestinoEmMetros',
        'duracaoParaDestinoEmSegundos',
      ],
      CargaDestinatario: ['nome', 'cpfCnpj', 'telefone', 'endereco', 'email'],
      CargaResponsavel: ['nome', 'cnpj'],
      SacResponse: ['attempt', 'status', 'event', 'date', 'shipperName'],
      CargaSessionPublicCnhIveco: [
        'nroNotaFiscal',
        'nroCte',
        'dataPrevisao',
        'dataPrevisaoAtualizadaPublic',
        'observacaoPrevisaoPublic',
        'distanciaParaDestinoEmMetros',
        'duracaoParaDestinoEmSegundos',
      ],
      CargaSessionPublicCnhIveco2: [
        'slaStatusTracking',
      ],
      CargaSessionPublicCnhIveco2ShowSacPrivado: [
        'slaStatusTracking',
        'lastUpdate',
      ],
    },
  }
}
